import React from 'react';

type Props = {
  result: 'success' | 'cancel';
};

export default function PaymentResult({ result }: Props) {
  const title = result === 'success' ? 'Payment successful' : 'Payment cancelled';
  const message = result === 'success'
    ? 'Thank you — your payment was received. If you do not receive access details by email shortly, please contact us.'
    : 'The payment was not completed. You can try again or contact support.';

  const handleBack = () => {
    // Navigate to app root
    try { window.location.href = '/'; } catch (e) { /* ignore */ }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
      <div style={{ background: '#fff', borderRadius: 10, padding: 24, width: 420, maxWidth: '92%', boxShadow: '0 12px 40px rgba(0,0,0,0.25)', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2 style={{ margin: '0 0 12px', color: result === 'success' ? '#0b9a49' : '#d32f2f' }}>{title}</h2>
        <p style={{ margin: '0 0 18px', color: '#333' }}>{message}</p>
        <p style={{ margin: '0 0 18px', color: '#555', fontSize: 14 }}>If you experience any problems please contact <a href="mailto:seaofcortezexplorer@gmx.net">seaofcortezexplorer@gmx.net</a></p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button onClick={handleBack} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #e0e0e0', background: '#1976d2', color: '#fff', cursor: 'pointer' }}>Back to app</button>
        </div>
      </div>
    </div>
  );
}
